export default "__VITE_ASSET__DhMhkaDc__"